import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { api } from '../../lib/api'

export default function HeadhunterDashboard() {
  const navigate = useNavigate()
  const [stats, setStats] = useState({ candidates: 0, jobs: 0 })
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    Promise.all([api.profiles.list(), api.jobs.list()])
      .then(([p, j]) => {
        setStats({
          candidates: p.data.length,
          jobs: j.data.filter((job) => job.status === 'Open' || job.status === 'Interviewing').length,
        })
      })
      .finally(() => setLoading(false))
  }, [])

  return (
    <div className="space-y-8">
      <div>
        <h1 className="text-3xl font-heading tracking-tactical">HEADHUNTER DASHBOARD</h1>
        <p className="text-text-muted text-sm mt-1">Match top talent to the right opportunities.</p>
      </div>

      {!loading && (
        <div className="grid grid-cols-2 gap-4 max-w-sm">
          <div className="bg-surface-low border border-border-subtle p-4">
            <p className="text-3xl font-heading text-primary">{stats.candidates}</p>
            <p className="text-xs text-text-muted tracking-tactical mt-1">CANDIDATES</p>
          </div>
          <div className="bg-surface-low border border-border-subtle p-4">
            <p className="text-3xl font-heading text-primary">{stats.jobs}</p>
            <p className="text-xs text-text-muted tracking-tactical mt-1">ACTIVE JOBS</p>
          </div>
        </div>
      )}

      <div className="flex flex-wrap gap-3">
        <button
          onClick={() => navigate('/headhunter/jobs')}
          className="bg-surface-low border border-border-subtle px-5 py-3 text-xs tracking-tactical text-foreground hover:border-primary hover:text-primary transition-colors"
        >
          BROWSE JOBS →
        </button>
        <button
          onClick={() => navigate('/headhunter/candidates')}
          className="bg-surface-low border border-border-subtle px-5 py-3 text-xs tracking-tactical text-foreground hover:border-primary hover:text-primary transition-colors"
        >
          VIEW CANDIDATES →
        </button>
        <button
          onClick={() => navigate('/headhunter/pipeline')}
          className="bg-surface-low border border-border-subtle px-5 py-3 text-xs tracking-tactical text-foreground hover:border-primary hover:text-primary transition-colors"
        >
          VIEW PIPELINE →
        </button>
      </div>
    </div>
  )
}
